import React, { useEffect, useState } from "react";
import { Box, CircularProgress, Typography } from "@mui/material";
import DashboardContainer from "../../components/dashboard-container";
import CustomPagination from "../../components/pagination";
import GeneratedSalesCartList from "../../components/generated-sales-cart-list";
import GeneratedSalesCartModal from "../../components/generated-sales-cart-modal";
import { generatedSalesCartService } from "../../utils/services/generated-sales-cart.service";

const NoDataState = () => (
  <Box
    sx={{
      minHeight: 360,
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      border: "1px dashed var(--border-color)",
      borderRadius: 3,
      backgroundColor: "var(--bg-paper)",
      color: "var(--text-secondary)",
      mb: 10,
    }}
  >
    <Typography fontFamily="Poppins">No generated sales carts found.</Typography>
  </Box>
);

export default function GeneratedSalesCart() {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(15);
  const [dataCount, setDataCount] = useState(0);
  const [searchValue, setSearchValue] = useState("");
  const [openModal, setOpenModal] = useState(false);
  const [selectedCart, setSelectedCart] = useState(null);

  const fetchGeneratedSalesCarts = async () => {
    setLoading(true);
    try {
      const skip = page * rowsPerPage;
      const response = await generatedSalesCartService.fetch(
        searchValue,
        rowsPerPage,
        skip,
      );
      setData(response.data || []);
      setDataCount(response.total || 0);
    } catch (error) {
      console.error("Failed to fetch generated sales carts", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchGeneratedSalesCarts();
  }, [page, rowsPerPage, searchValue]);

  return (
    <DashboardContainer
      filterButton={false}
      hideFilterClient
      hideUploadButton
      header="Generated Sales Cart"
      title="+ Generated Sales Cart"
      searchBarPlaceholder="Search by customer, status, or SKU"
      onSearchData={(value) => {
        setSearchValue(value);
        setPage(0);
      }}
      onClickAddButton={() => {
        setSelectedCart(null);
        setOpenModal(true);
      }}
      onClickRefresh={fetchGeneratedSalesCarts}
    >
      <GeneratedSalesCartModal
        open={openModal}
        selectedCart={selectedCart}
        handleClose={() => {
          setOpenModal(false);
          setSelectedCart(null);
        }}
        onSubmitSuccess={fetchGeneratedSalesCarts}
      />

      {loading && (
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            position: "fixed",
            inset: 0,
            backgroundColor: "rgba(0, 0, 0, 0.35)",
            zIndex: 9999,
            color: "white",
          }}
        >
          <CircularProgress color="inherit" />
        </Box>
      )}

      {data.length ? (
        <GeneratedSalesCartList
          data={data}
          onEditData={(cart) => {
            setSelectedCart(cart);
            setOpenModal(true);
          }}
          onDeleteSuccess={fetchGeneratedSalesCarts}
        />
      ) : (
        !loading && <NoDataState />
      )}

      <CustomPagination
        dataCount={dataCount}
        rowsPerPage={rowsPerPage}
        page={page}
        setPage={setPage}
        setRowsPerPage={setRowsPerPage}
        disableNext={dataCount <= rowsPerPage * (page + 1)}
      />
    </DashboardContainer>
  );
}
